import {
  Box,
  Button,
  TextField,
  Typography,
  Link as MuiLink,
  InputAdornment,
  Container,
  Paper,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { Person, Lock, Email, LockOpen } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import Cookies from "js-cookie";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useAuth } from "utils/AuthContext";

const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

const LeftPanel = styled(Box)(({ theme }) => ({
  background: "linear-gradient(195deg,  #004030, #191919)",
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  minHeight: "100vh",
  [theme.breakpoints.down("md")]: {
    minHeight: "40vh",
    flex: "none",
  },
  [theme.breakpoints.down("sm")]: {
    minHeight: "35vh",
  },
  "&::before": {
    content: '""',
    position: "absolute",
    bottom: -200,
    left: -200,
    width: 400,
    height: 400,
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    [theme.breakpoints.down("md")]: {
      bottom: -150,
      left: -150,
      width: 300,
      height: 300,
    },
    [theme.breakpoints.down("sm")]: {
      bottom: -100,
      left: -100,
      width: 200,
      height: 200,
    },
  },
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: -100,
    left: -100,
    width: 250,
    height: 250,
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "50%",
    [theme.breakpoints.down("md")]: {
      bottom: -75,
      left: -75,
      width: 150,
      height: 150,
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const RightPanel = styled(Box)(({ theme }) => ({
  backgroundColor: "#f5f5f5",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  minHeight: "100vh",
  padding: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    minHeight: "60vh",
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    minHeight: "65vh",
    padding: theme.spacing(1),
  },
}));

const BrandContent = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 10,
  color: "white",
  maxWidth: 400,
  padding: theme.spacing(0, 4),
  textAlign: "left",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(0, 3),
    maxWidth: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0, 2),
  },
}));

const LoginForm = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: "100%",
  maxWidth: 400,
  backgroundColor: "white",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(3),
    margin: theme.spacing(0, 1),
    borderRadius: theme.spacing(1),
  },
}));

export default function Basic() {
  const { login: authLogin } = useAuth();
  const [state, setState] = useState({
    open: false,
    severity: "success",
    vertical: "top",
    horizontal: "right",
    message: "",
  });
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const { vertical, horizontal, open, message, severity } = state;
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const validationSchema = () => {
    return Yup.object().shape({
      txtEmail: Yup.string().email("Invalid email").required("Email is required"),
      txtPassword: Yup.string()
        // .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });
  };
  const formik = useFormik({
    initialValues: {
      txtEmail: "",
      txtPassword: "",
    },
    validationSchema: validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    // onSubmit: async (values) => {
    //   console.log("🚀 ~ onSubmit: ~ values:", values);
    //   try {
    //     const encryptedData = CryptoJS.AES.encrypt(
    //       JSON.stringify(values),
    //       process.env.REACT_APP_SECRET_KEY
    //     ).toString();

    //     await axios({
    //       method: "post",
    //       url: `${process.env.REACT_APP_API_URL}/auth/login`,
    //       data: { payload: encryptedData },
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       withCredentials: true,
    //     })
    //       .then(async function (response) {
    //         if (response.data.status === 200) {
    //           setState({
    //             ...state,
    //             open: true,
    //             severity: "success",
    //             message: response.data.message,
    //           });

    //           const authResponse = await axios.post(
    //         `${process.env.REACT_APP_API_URL}/auth/me`,
    //         {},
    //         { withCredentials: true }
    //       );
    //       const { role_id } = authResponse.data;

    //       const redirectPath = localStorage.getItem("postLoginRedirect");

    //           setTimeout(() => {
    //         if (redirectPath) {
    //           navigate(redirectPath);
    //           localStorage.removeItem("postLoginRedirect");
    //         } else {
    //           if (role_id === 1) {
    //             navigate("/dashboard");
    //           } else if (role_id === 3) {
    //             navigate("/profile");
    //           } else {
    //             navigate("/dashboard"); // fallback
    //           }
    //         }
    //       }, 2000);
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         if (error.status === 401) {
    //           setState({
    //             ...state,
    //             open: true,
    //             severity: "error",
    //             message: error.response.data.error,
    //           });
    //         } else if (error.status === 500) {
    //           setState({
    //             ...state,
    //             open: true,
    //             severity: "error",
    //             message: error.response.data.error,
    //           });
    //         }
    //       });
    //   } catch (error) {
    //     console.log("error :", error);
    //     console.error(error.status);
    //   }
    // },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(values),
          process.env.REACT_APP_SECRET_KEY
        ).toString();

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/login`,
          { payload: encryptedData },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );

        if (response.data.status === 200) {
          // Store token for backup if cookies are blocked
          if (response.data.token) {
            localStorage.setItem("authToken", response.data.token);
          }
          
          setState({
            ...state,
            open: true,
            severity: "success",
            message: response.data.message,
          });

          // Step 1: Fetch user details to update AuthContext
          try {
            const authResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/auth/me`,
              {},
              {
                headers: { Authorization: `Bearer ${response.data.token}` },
                withCredentials: true,
              }
            );

            const userData = authResponse.data;
            const { role_id } = userData;

            // Update AuthContext
            authLogin(userData);

            // Step 2: Get post-login redirect path
            const redirectPath = localStorage.getItem("postLoginRedirect");
            // console.log("Redirect path from localStorage:", redirectPath);

            // Step 3: Navigate based on redirect or role_id
            if (redirectPath) {
              navigate(redirectPath);
              localStorage.removeItem("postLoginRedirect");
            } else {
              if (role_id === 1 || role_id === 2) {
                navigate("/dashboard");
              } else if (role_id === 3) {
                navigate("/user-dashboard");
              } else {
                navigate("/dashboard");
              }
            }
          } catch (authError) {
            console.error("Failed to fetch user role after login:", authError);
            navigate("/dashboard");
          }
        }
      } catch (error) {
        console.error("Login error:", error);

        setState({
          ...state,
          open: true,
          severity: "error",
          message: error?.response?.data?.error || "Login failed. Please try again.",
        });
      } finally {
        setLoading(false); // hide loader
      }
    },
  });

  return (
    <MainContainer>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
          style={{ color: "white" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Backdrop open={loading} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Left Side - Branding */}
      <LeftPanel>
        <BrandContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 3 },
            textAlign: { xs: "center", sm: "left" },
            maxWidth: { xs: "100%", sm: 600 },
          }}
        >
          <Box
            component="img"
            src="https://tnclimatechangemission.in/images/logo.svg"
            alt="CMGFP Logo"
            sx={{
              width: { xs: 100, sm: 120, md: 140 },
              height: "auto",
            }}
          />
          <Box>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: "bold",
                mb: 0.5,
                fontSize: {
                  xs: "2rem",
                  sm: "2.5rem",
                  md: "3rem",
                  lg: "3.5rem",
                },
              }}
              style={{ color: "white" }}
            >
              CMGFP
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 0,
                lineHeight: 1.2,
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem",
                  md: "1.1rem",
                },
                px: { xs: 1, sm: 0 },
              }}
              style={{ color: "white", fontWeight: "700" }}
            >
              {"Chief Minister's Green Fellowship Programme"}
            </Typography>
          </Box>
        </BrandContent>
      </LeftPanel>

      {/* Right Side - Login Form */}
      <RightPanel>
        <Container
          sx={{ px: { xs: 1, sm: 3 } }}
          display="flex"
          // justifyContent="center"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <LoginForm elevation={0}>
            <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4 } }}>
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  color: "text.primary",
                  fontSize: {
                    xs: "1.75rem",
                    sm: "2rem",
                    md: "2.125rem",
                  },
                }}
              >
                Login
              </Typography>

            </Box>

            <Box component="form" sx={{ mt: { xs: 2, sm: 3 } }}>

              <TextField
                error={formik.errors.txtEmail}
                fullWidth
                label="Email"
                onChange={formik.handleChange("txtEmail")}
                helperText={formik.errors.txtEmail}
                sx={{
                  mb: { xs: 1.5, sm: 2 },
                  "& .MuiOutlinedInput-root": {
                    height: { xs: 48, sm: 56 },
                    backgroundColor: "white",
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                  },
                }}
              />
              <TextField
                error={formik.errors.txtPassword}
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                onChange={formik.handleChange("txtPassword")}
                helperText={formik.errors.txtPassword}
                size="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={showPassword ? "hide the password" : "display the password"}
                        onClick={handleClickShowPassword}
                        // onMouseDown={handleMouseDownPassword}
                        // onMouseUp={handleMouseUpPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <IconEye sx={{ color: "text.secondary" }} />
                        ) : (
                          <IconEyeOff sx={{ color: "text.secondary" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 1.5, sm: 2 },
                  "& .MuiOutlinedInput-root": {
                    height: { xs: 48, sm: 56 },
                    backgroundColor: "white",
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                  },
                }}
              />
              {/* <TextField
                fullWidth
                type="password"
                placeholder="Password"
                variant="outlined"
                margin="normal"
                onChangeText={formik.handleChange("txtPassword")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    height: { xs: 48, sm: 56 },
                    backgroundColor: "white",
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                  },
                }}
              /> */}

              <Button
                onClick={() => formik.handleSubmit()}
                fullWidth
                variant="contained"
                // color="primary"
                size="large"
                style={{ color: "white" }}
                sx={{
                  height: { xs: 48, sm: 56 },
                  backgroundColor: "#004030bf",
                  "&:hover": {
                    backgroundColor: "#004030",
                  },
                  borderRadius: 2,
                  textTransform: "none",
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  fontWeight: 500,
                  mb: { xs: 2, sm: 3 },
                }}
                disabled={loading}
              >
                Login
              </Button>

              <Box sx={{ textAlign: "center", mt: 2 }}>

                <MuiLink
                  component={RouterLink}
                  // to="/forgot-password"
                  to="/send-otp"

                  sx={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontSize: { xs: "0.8rem", sm: "0.875rem" },
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Forgot Password?
                </MuiLink>
              </Box>
            </Box>
          </LoginForm>
        </Container>
      </RightPanel>
    </MainContainer>
  );
}
